/**
 * The provider's picture at the size it is drawn. Steam hands the platform its
 * 184-px `_full` picture and Discord its default; both serve smaller ones at a
 * neighbouring address, and a 20-px face on a list of missions needs no more
 * than 64 px (a page of mission cards fetched one 184-px picture per card).
 */
export function avatarAt(url: string, size: number): string {
  if (/steamstatic\.com\/.+_full\.jpg$/.test(url) && size <= 40) {
    return url.replace(/_full\.jpg$/, '_medium.jpg');
  }
  if (/^https:\/\/cdn\.discordapp\.com\/avatars\//.test(url) && !url.includes('size=')) {
    const px = [32, 64, 128, 256].find((n) => n >= size * 2) ?? 512;
    return `${url}${url.includes('?') ? '&' : '?'}size=${px}`;
  }
  return url;
}
